import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import logo from '../../assets/logo-danes.png';
import BrandLogo from '../common/BrandLogo';

const PaymentScreen = () => {
    const { total, items } = useCart();
    const navigate = useNavigate();
    const [isAnimating, setIsAnimating] = useState(false);
    const [showAnimation, setShowAnimation] = useState(false);

    useEffect(() => {
        setTimeout(() => setShowAnimation(true), 50);
    }, []);

    const ivaAmount = total * 0.19;
    const subtotalWithoutTax = total - ivaAmount;

    const handleProceedToPayment = () => {
        if (items.length === 0) {
            alert('Tu carrito está vacío. Agrega productos para proceder al pago.');
            return;
        }

        setIsAnimating(true);
        setTimeout(() => {
            navigate('/payment-method');
        }, 300);
    };

    const handleBackToProducts = () => {
        setIsAnimating(true);
        setTimeout(() => {
            navigate('/', { replace: true });
        }, 300);
    };

    return (
        <div className="payment-container-fixed" style={{ backgroundColor: 'transparent' }}>
            <BrandLogo delay={0.3} topPosition="56px" />

            <div className="payment-header-fixed">
                <button
                    onClick={handleBackToProducts}
                    className="back-button-fixed"
                    disabled={isAnimating}
                >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 18l-6-6 6-6" />
                    </svg>
                </button>

                <img src={logo} alt="Danés" className="header-logo-payment" />

                <div className="header-text-fixed">
                    <h1 className="payment-title-fixed">Resumen de tu Pedido</h1>
                    <p className="payment-subtitle-fixed">Revisa tus productos antes de continuar</p>
                </div>

                <div className="items-count-fixed">
                    {items.reduce((sum, item) => sum + item.quantity, 0)} PRODUCTOS
                </div>
            </div>

            <div className="products-area-fixed">
                {items.map((item, index) => (
                    <div
                        key={item.id}
                        className="product-item-fixed"
                        style={{ animationDelay: `${index * 100}ms` }}
                    >
                        <div className="product-image-container-fixed">
                            {item.image_url || item.cached_image_url ? (
                                <img
                                    src={item.cached_image_url
                                        ? `http://localhost:9000${item.cached_image_url}`
                                        : `http://158.220.126.252:8071${item.image_url}`
                                    }
                                    alt={item.name}
                                    className="product-image-fixed"
                                    onError={(e) => {
                                        e.target.style.display = 'none';
                                        e.target.nextSibling.style.display = 'flex';
                                    }}
                                />
                            ) : null}
                            <div className="image-placeholder-fixed" style={{ display: item.image_url || item.cached_image_url ? 'none' : 'flex' }}>
                                <svg viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
                                </svg>
                            </div>
                        </div>

                        <div className="product-info-fixed">
                            <h3 className="product-name-fixed">{item.name}</h3>

                            {item.customDescription && (
                                <div className="customization-fixed">
                                    <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                                        <circle cx="12" cy="12" r="10" />
                                    </svg>
                                    <div className="customization-content">
                                        <span className="customization-label">PERSONALIZADO</span>
                                        <span className="customization-text">{item.customDescription}</span>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="product-right">
                            <div className="product-quantity-fixed">
                                <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                                    <rect x="3" y="3" width="7" height="7" rx="1" />
                                    <rect x="3" y="14" width="7" height="7" rx="1" />
                                    <rect x="14" y="3" width="7" height="7" rx="1" />
                                    <rect x="14" y="14" width="7" height="7" rx="1" />
                                </svg>
                                <span>{item.quantity}</span>
                            </div>

                            <div className="product-price-fixed">
                                <p className="unit-price">${item.price} c/u</p>
                                <p className="total-price">${item.price * item.quantity}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="summary-area">
                <div className="price-summary-fixed">
                    <div className="summary-row-fixed">
                        <span className="summary-label-fixed">Subtotal (Neto):</span>
                        <span className="summary-value-fixed">${Math.round(subtotalWithoutTax).toLocaleString()}</span>
                    </div>
                    <div className="summary-row-fixed">
                        <span className="summary-label-fixed">IVA (19%):</span>
                        <span className="summary-value-fixed">${Math.round(ivaAmount).toLocaleString()}</span>
                    </div>
                    <div className="total-row-fixed">
                        <span className="total-label-fixed">Total a Pagar:</span>
                        <span className="total-value-fixed">${total.toLocaleString()}</span>
                    </div>
                </div>

                <div className="action-buttons-fixed">
                    <button className="back-menu-button-fixed" onClick={handleBackToProducts}>
                        ← VOLVER AL MENÚ
                    </button>
                    <button className="proceed-button-fixed" onClick={handleProceedToPayment}>
                        PROCEDER AL PAGO →
                    </button>
                </div>
            </div>

            <style jsx>{`
                .payment-container-fixed {
                    min-height: 100vh;
                    display: flex;
                    flex-direction: column;
                    opacity: ${showAnimation && !isAnimating ? 1 : 0};
                    transform: ${showAnimation && !isAnimating ? 'translateY(0)' : 'translateY(20px)'};
                    transition: all 400ms cubic-bezier(0.4, 0, 0.2, 1);
                    position: relative;
                }

                .payment-header-fixed {
                    background: #009542;
                    padding: 1rem 1.5rem;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    gap: 1.5rem;
                    position: relative;
                    z-index: 2;
                }

                .back-button-fixed {
                    width: 56px;
                    height: 56px;
                    border: none;
                    background: rgba(255, 255, 255, 0.2);
                    border-radius: 16px;
                    color: white;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 200ms ease;
                    flex-shrink: 0;
                }

                .back-button-fixed:hover {
                    background: rgba(255, 255, 255, 0.3);
                }

                .header-logo-payment {
                    height: 80px;
                    width: auto;
                    flex-shrink: 0;
                }

                .header-text-fixed {
                    flex: 1;
                    min-width: 0;
                }

                .payment-title-fixed {
                    font-size: 2rem;
                    font-weight: 700;
                    color: white;
                    margin: 0 0 0.25rem 0;
                }

                .payment-subtitle-fixed {
                    font-size: 1.125rem;
                    color: rgba(255, 255, 255, 0.9);
                    margin: 0;
                }

                .items-count-fixed {
                    background: white;
                    color: #009542;
                    padding: 0.75rem 1.5rem;
                    border-radius: 12px;
                    font-size: 1rem;
                    font-weight: 700;
                    white-space: nowrap;
                    flex-shrink: 0;
                    margin-right: 300px;
                }

                .products-area-fixed {
                    flex: 1;
                    padding: 1.5rem;
                    max-width: 1200px;
                    margin: 0 auto;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                    overflow-y: auto;
                    position: relative;
                    z-index: 1;
                }

                .product-item-fixed {
                    background: #E5DFD2;
                    border: 3px solid #E5DFD2n;
                    border-radius: 20px;
                    padding: 1.5rem;
                    display: flex;
                    align-items: center;
                    gap: 1.5rem;
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
                    animation: slideInUp 400ms ease-out;
                    animation-fill-mode: both;
                    min-height: 120px;
                }

                .product-image-container-fixed {
                    width: 100px;
                    height: 100px;
                    border-radius: 16px;
                    overflow: hidden;
                    background: #f5f5f5;
                    flex-shrink: 0;
                }

                .product-image-fixed {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

                .image-placeholder-fixed {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #d1d5db;
                }

                .image-placeholder-fixed svg {
                    width: 48px;
                    height: 48px;
                }

                .product-info-fixed {
                    flex: 1;
                }

                .product-name-fixed {
                    font-size: 1.5rem;
                    font-weight: 700;
                    color: #1f2937;
                    margin: 0 0 0.75rem 0;
                }

                .customization-fixed {
                    display: flex;
                    align-items: flex-start;
                    gap: 0.625rem;
                    padding: 0.75rem 1.125rem;
                    background: #fff5f0;
                    border-radius: 10px;
                    border-left: 4px solid #009542;
                }

                .customization-fixed svg {
                    color: #009542;
                    flex-shrink: 0;
                    margin-top: 2px;
                }

                .customization-content {
                    display: flex;
                    flex-direction: column;
                    gap: 0.25rem;
                }

                .customization-label {
                    font-size: 0.75rem;
                    font-weight: 700;
                    color: #009542;
                    letter-spacing: 0.5px;
                }

                .customization-text {
                    font-size: 1rem;
                    color: #6b7280;
                    font-weight: 600;
                }

                .product-right {
                    display: flex;
                    align-items: center;
                    gap: 2rem;
                }

                .product-quantity-fixed {
                    display: flex;
                    align-items: center;
                    gap: 0.75rem;
                    background: #f5f5f5;
                    padding: 0.75rem 1.25rem;
                    border-radius: 12px;
                    color: #009542;
                    font-size: 1.5rem;
                    font-weight: 700;
                }

                .product-price-fixed {
                    text-align: right;
                    min-width: 120px;
                }

                .unit-price {
                    font-size: 0.875rem;
                    color: #9ca3af;
                    margin: 0 0 0.25rem 0;
                }

                .total-price {
                    font-size: 1.75rem;
                    font-weight: 700;
                    color: #009542;
                    margin: 0;
                }

                .summary-area {
                    padding: 1.5rem;
                    max-width: 1200px;
                    margin: 0 auto;
                    width: 100%;
                    position: relative;
                    z-index: 1;
                }

                .price-summary-fixed {
                    background: #E5DFD2;
                    padding: 1.5rem;
                    border-radius: 16px;
                    margin-bottom: 1.5rem;
                }

                .summary-row-fixed {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 0.875rem;
                    font-size: 1.125rem;
                }

                .summary-label-fixed {
                    color: #6b7280;
                    font-weight: 600;
                }

                .summary-value-fixed {
                    font-weight: 700;
                    color: #374151;
                }

                .total-row-fixed {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border-top: 3px solid #009542;
                    margin-top: 1.25rem;
                    padding-top: 1.25rem;
                }

                .total-label-fixed {
                    font-size: 1.5rem;
                    font-weight: 800;
                    color: #1f2937;
                }

                .total-value-fixed {
                    font-size: 2.75rem;
                    font-weight: 900;
                    color: #009542;
                }

                .action-buttons-fixed {
                    display: flex;
                    gap: 1rem;
                }

                .back-menu-button-fixed {
                    flex: 1;
                    padding: 1.125rem 2rem;
                    border: none;
                    border-radius: 16px;
                    font-size: 1.125rem;
                    font-weight: 700;
                    cursor: pointer;
                    transition: all 200ms ease;
                    background: #6b7280;
                    color: white;
                }

                .back-menu-button-fixed:hover {
                    background: #4b5563;
                }

                .proceed-button-fixed {
                    flex: 2;
                    padding: 1.125rem 2rem;
                    border: none;
                    border-radius: 16px;
                    font-size: 1.25rem;
                    font-weight: 700;
                    cursor: pointer;
                    transition: all 200ms ease;
                    background: #009542;
                    color: white;
                }

                .proceed-button-fixed:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 16px rgba(24, 22, 19, 0.3);
                }

                @keyframes slideInUp {
                    0% {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    100% {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @media (max-width: 768px) {
                    .product-item-fixed {
                        flex-direction: column;
                        text-align: center;
                    }

                    .action-buttons-fixed {
                        flex-direction: column;
                    }

                    .product-right {
                        width: 100%;
                        justify-content: space-between;
                    }
                }
            `}</style>
        </div>
    );
};

export default PaymentScreen;